import React from 'react';

import { createTimeTrackingEntry } from '@shared/time-tracking-entries/endpoints/createTimeTrackingEntry';
import { Portlet } from '@shared/ui/components/Portlet';
import { PropsWithClassName } from '@shared/utils/types';

import { StartTimeTrackingWithCrewMemberForm } from '@admin/time-tracking/components/StartTimeTrackingWithCrewMemberForm/StartTimeTrackingWithCrewMemberForm';

type Props = {
  timeTrackingGroupId: number;
  onStartOrEnd?: () => void;
};

export default function CrewMemberTimeTrackingPortlet({
  timeTrackingGroupId,
  onStartOrEnd,
  className,
}: PropsWithClassName<Props>) {
  return (
    <Portlet className={className}>
      <StartTimeTrackingWithCrewMemberForm
        timeTrackingGroupId={timeTrackingGroupId}
        action={createTimeTrackingEntry}
        onSave={() => onStartOrEnd?.()}
      />
    </Portlet>
  );
}
